<template>
  <div class="partyAform">
    <div class="newContract-form" v-if="init">
      <el-form :inline="true" :model="partyAInformation" class="demo-form-inline">
        <el-form-item label="甲方 :" class="ringr">
          <el-input
            v-model="partyAInformation.name"
            placeholder="请输入甲方"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="法定代理人 :">
          <el-input
            v-model="partyAInformation.iegalRepresentative"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码 :">
          <el-input
            v-model="partyAInformation.unifiedSocialCreditCode"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理人 :">
          <el-input
            v-model="partyAInformation.agent"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话 :">
          <el-input
            v-model="partyAInformation.phone"
            :disabled="true"
          ></el-input>
        </el-form-item>
       
       
      </el-form>
       <el-form :inline="true" :model="partyAInformation" class="demo-form-inline">
         <el-form-item label="身份证号码 :">
          <el-input
            v-model="partyAInformation.identificationNum"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="户名 :" class="huName">
          <el-input
            v-model="partyAInformation.accountName"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户行 :" style="padding-left: 70px;">
          <el-input
            v-model="partyAInformation.accountBank"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="账号 :" style="padding-left: 10px;">
          <el-input
            v-model="partyAInformation.account"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="地址 :" style="padding-left: 30px;">
          <el-input
            v-model="partyAInformation.address"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="partyBform" v-else>
      <div class="newContract-form">
        <el-form :inline="true" :model="partyAInformation" class="demo-form-inline">
          <el-form-item label="甲方 :">
            <el-input
              v-model="partyAInformation.name"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="代理人 :">
            <el-input
              v-model="partyAInformation.agent"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话 :">
            <el-input
              v-model="partyAInformation.phone"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号码 :">
            <el-input
              v-model="partyAInformation.identificationNum"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址 :">
            <el-input
              v-model="partyAInformation.address"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {
  name: 'partyAform',
  props: {
    auditDetails: {
      type: Boolean,
      default: true
    },
    init: {
      type: Boolean,
      default: true
    },
    firstContractUser: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      merchantsDate: [],
      merchantName: '',
      phone: '',
      boothOwnerId: '',
      miId: '',
      partyAInformation: {
        agent: '', // 代理人
        iegalRepresentative: '', // 法定代理人
        unifiedSocialCreditCode: '', // 统一社会信用代码
        phone: '', // 联系电话
        identificationNum: '', // 身份证号码
        accountName: '', // 户名
        accountBank: '', // 开户行
        account: '', // 账号
        address: '',
        name: '',
        identity: '',
        isMarketSide: ''
      },
      page: {
        pageSize: 10,
        currentPage: 1
      },
      total: 0
    }
  },
  watch: {
    firstContractUser: {
      handler: function () {
        this.partyAInformation.agent = this.firstContractUser.agent
        this.partyAInformation.iegalRepresentative = this.firstContractUser.iegalRepresentative
        this.partyAInformation.unifiedSocialCreditCode =
          this.firstContractUser.unifiedSocialCreditCode
        this.partyAInformation.phone = this.firstContractUser.phone
        this.partyAInformation.identificationNum = this.firstContractUser.identificationNum
        this.partyAInformation.accountName = this.firstContractUser.accountName
        this.partyAInformation.accountBank = this.firstContractUser.accountBank
        this.partyAInformation.account = this.firstContractUser.account
        this.partyAInformation.address = this.firstContractUser.address
        this.partyAInformation.name = this.firstContractUser.name
        this.partyAInformation.identity = this.firstContractUser.identity
        this.partyAInformation.isMarketSide = this.firstContractUser.isMarketSide
        this.partyAInformation.merchantId = this.firstContractUser.merchantId
        this.partyAInformation.id = this.firstContractUser.id
      },
      deep: true
    },
    natureA: {
      handler: function () {
        if (this.natureA === 'N') {
          this.partyAInformation.identity = 0
        } else {
          this.partyAInformation.identity = 1
        }
      }
    },
    partyAInformation: {
      handler: function () {
        this.$emit('partyAInformation', this.partyAInformation)
      },
      deep: true
    },
  },
  methods: {
  }
}
</script>
<style lang="scss">
.partyAform {
  .eldialog-tabeDate {
    margin-top: 20px;
  }
  .dialog-input {
    display: inline-block;
    margin-left: 10px;
  }
  .el-input--small {
    width: 140px;
  }
  .dialogName {
    width: 230px;
    display: inline-block;
  }
  .Nuber {
    margin-left: 20px;
  }
  .eldialog-button {
    display: inline-block;
    width: 400px;
    text-align: right;
  }
  .partyBform {
    .newContract-form {
      .el-form-item:nth-of-type(1) {
        .el-form-item__label {
          padding-left: 70px;
        }
      }
      .el-form-item:nth-of-type(5) {
        .el-form-item__label {
          padding-left: 10px;
        }
      }
      .el-form {
        width: 90%;
      }
      .el-form-item--small.el-form-item {
        margin-right: 170px !important;
      }
    }
  }
  .newContract-form {
   .ringr{
     padding-left: 40px;
   }
   .huName{
     padding-left: 40px;
   }
  }
}
</style>
